/* eslint-disable no-restricted-globals */ const DEFAULT_ENVIRONMENT = 'production';
const environment = ()=>{
    let env = DEFAULT_ENVIRONMENT;
    try {
        env = process.env.NODE_ENV || DEFAULT_ENVIRONMENT;
    } catch (err) {
    // Do nothing.
    }
    return env;
};
export function getEnvEnvironment() {
    return environment();
}
// For SSR, we only based the environment in the process.env variable.
function getHostname() {
    if (typeof globalThis !== 'undefined') {
        var _globalThis_location, _globalThis;
        return (_globalThis = globalThis) === null || _globalThis === void 0 ? void 0 : (_globalThis_location = _globalThis.location) === null || _globalThis_location === void 0 ? void 0 : _globalThis_location.hostname;
    }
    if (typeof self !== 'undefined') {
        var _self_location, _self;
        return (_self = self) === null || _self === void 0 ? void 0 : (_self_location = _self.location) === null || _self_location === void 0 ? void 0 : _self_location.hostname;
    }
    if (typeof window !== 'undefined') {
        var _window_location, _window;
        return (_window = window) === null || _window === void 0 ? void 0 : (_window_location = _window.location) === null || _window_location === void 0 ? void 0 : _window_location.hostname;
    }
    return undefined;
}
function isUserHostname() {
    const hostname = getHostname();
    let result = false;
    try {
        result = !!(process.env.USER && hostname && hostname.includes(String(process.env.USER)));
    } catch (err) {
    // Do nothing.
    }
    return result;
}
function isDevHostname() {
    const hostname = getHostname();
    if (!hostname) {
        return false;
    }
    return /\.stripe$/.test(hostname) || /\.stripe\.me$/.test(hostname) || /\bedge-\b.*\.stripe\.com$/.test(hostname) || /\bpreprod\b.*\.stripe\.com$/.test(hostname) || /\bqa\b.*\.stripe\.com$/.test(hostname) || /\bqa\b.*\.stripecdn\.com$/.test(hostname) || /\preprod\b.*\.stripecdn\.com$/.test(hostname) || /^127(?:\.\d+){3}$/.test(hostname) || /^localhost$/.test(hostname);
}
function isDevEnvironment() {
    return ![
        'production',
        'test'
    ].includes(getEnvEnvironment()) || isDevHostname() || isUserHostname();
}
function isTestEnvironment() {
    return getEnvEnvironment() === 'test';
}
export default function getEnvironment() {
    if (isTestEnvironment()) {
        return 'test';
    }
    return isDevEnvironment() ? 'development' : getEnvEnvironment();
}

//# sourceMappingURL=getEnvironment.js.map